var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttachment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.8705 5.06125L5.8655 8.06625C5.1825 8.74925 5.1825 9.85725 5.8655 10.5413C6.5485 11.2243 7.6565 11.2243 8.3405 10.5413L12.4065 6.47525C13.7735 5.10825 13.7735 2.89225 12.4065 1.52525C11.0395 0.15825 8.8235 0.15825 7.4565 1.52525L3.0375 5.94525C0.9875 7.99525 0.9875 11.3193 3.0375 13.3703C5.0875 15.4203 8.4115 15.4203 10.4625 13.3703L14.5275 9.30425",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachment);
export default __webpack_public_path__ + "static/media/Attachment.443bd203b849ab60142d494572c0386b.svg";
export { ForwardRef as ReactComponent };